// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2FluZ","tab":"ProcedureTabs_tab__3YTnl"};